import { FullAudit, IsActiveFlag, LevelModel } from '@/types';

export interface WordModel extends IsActiveFlag, FullAudit {
    id: number;
    levelId: number;
    level: LevelModel;
    word: string;
    callParticipant: string;
}
